import React from "react";
import { PL, PS } from "../ui/typography";
import {
  detailsContainer,
  avatarContainer,
  clientInfoContainer,
  subText as subTextSelector
} from "./avatar-detail.module.css";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

interface AvatarDetailsProps extends React.HTMLProps<HTMLDivElement> {
  subText: string;
  avatar?: IGatsbyImageData;
  name: string;
  altText?: string;
}

const AvatarDetails: React.FC<AvatarDetailsProps> = ({
  name,
  subText,
  avatar,
  className,
  altText = "Avatar"
}) => {
  return (
    <div className={`${detailsContainer} ${className}`}>
      <div className={avatarContainer}>
        {avatar && <GatsbyImage image={avatar} alt={altText} />}
      </div>
      <div className={clientInfoContainer}>
        <PL className="text-dark">{name}</PL>
        <div className={subTextSelector}>
          <PS className="text-dark">{subText}</PS>
        </div>
      </div>
    </div>
  );
};

export default AvatarDetails;
